export default class RequestHandler {
    static setServerToken(token) {
        this._token = token;
    }
    static setServerRefreshToken(refreshToken) {
        this._refreshToken = refreshToken;
    }
    static setServerExpired(expired) {
        this._expired = expired;
    }
    static setServerAgent(userAgent) {
        this._userAgent = userAgent;
    }
    static getServerToken() {
        return this._token;
    }
    static getServerRefreshToken() {
        return this._refreshToken;
    }
    static getServerExpired() {
        return this._expired;
    }
    static getServerAgent() {
        return this._userAgent;
    }
}
